import * as types from '../const/action.types';
import { put } from '../api/_basic';

export function reportsDecreaseIsLoading(bool) {
    return {
        type: types.REPORT_DECREASE_IS_LOADING,
        isLoading: bool,
    };
}

export function reportsDecreaseLocalsFetchDataSuccess(items) {
    return {
        type: types.REPORT_DECREASE_LOCALS_FETCH_DATA,
        items,
    };
}

export function reportsDecreaseValuesFetchDataSuccess(items) {
    return {
        type: types.REPORT_DECREASE_VALUES_FETCH_DATA,
        items,
    };
}

export function loadInfoDecrease(localsInfo, from, to) {
    console.log('loadInfoDecrease');
    return async (dispatch) => {
        dispatch(reportsDecreaseIsLoading(true));
        dispatch(reportsDecreaseValuesFetchDataSuccess([]));
        try {
            const body = {};
            if (from) body.desde = from;
            if (to) body.hasta = to;
            if (localsInfo) body.locales = localsInfo;

            put(process.env.REACT_APP_API_DECREASE, body)
                .then((result) => {
                    dispatch(reportsDecreaseIsLoading(false));
                    if (result.error !== undefined) {
                        console.error(result.error);
                        throw Error(result.error);
                    }
                    dispatch(reportsDecreaseValuesFetchDataSuccess(result.data));
                })
                .catch((error) => {
                    dispatch(reportsDecreaseIsLoading(false));
                    throw error;
                });
        } catch (error) {
            dispatch(reportsDecreaseIsLoading(false));
            throw error;
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.reports.decrease.actions.js